// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"5ffb5b0d","322":"5ffb5b0d"}[chunkId] + ".chunk.css";
};